import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import SchedulePage from "../pages/schedule/page";
import LiveDetailPage from "../pages/live/page";
import ReplayPage from "../pages/replay/page";
import AboutPage from "../pages/about/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/schedule",
    element: <SchedulePage />,
  },
  {
    path: "/live/:id",
    element: <LiveDetailPage />,
  },
  {
    path: "/replay",
    element: <ReplayPage />,
  },
  {
    path: "/about",
    element: <AboutPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;